import { IconProps, Icon as IconType } from '@iconscout/react-unicons';

// const Unicon = ({ icon: Icon, ...rest }: IconProps & { icon: IconType }) => {
const Unicon = ({ icon: Icon, ...rest }: any) => {
  return <Icon {...rest} />;
};

export default Unicon;
